import { LocalAccountSigner } from "@aa-sdk/core";
import { userSmartAccount, userSmartAccountClient } from "../components/RecoilAtom";
import { useRecoilValue } from "recoil";
import { getIndexKey, saveIndexKey } from "../components/indexDb";
import { generatePrivateKey, privateKeyToAccount } from "viem/accounts";
import { ACTIVE_SESSION_TIME } from "../utils/Enviroment";
import { handleCheckSession } from "../utils/helpers";


export const useSessionPermissions = () => {
    const smartAccountClient = useRecoilValue(userSmartAccountClient)
    const smartAccount = useRecoilValue(userSmartAccount);

    const grantPermissions = async () => {
        if (smartAccountClient && smartAccount) {
            try {
                const stored = await getIndexKey('sessionKeyData');
                const isSessionValid = await handleCheckSession()
                if (isSessionValid) {
                    console.log('Session has expired, granting new permissions');

                    const sessionTime = ACTIVE_SESSION_TIME
                    const privateKey = generatePrivateKey();
                    const account = privateKeyToAccount(privateKey);
                    const sessionKey = new LocalAccountSigner(account);

                    const permissions = await smartAccountClient?.grantPermissions({
                        account: smartAccount,
                        expirySec: sessionTime,
                        key: {
                            publicKey: await sessionKey?.getAddress(),
                            type: "secp256k1",
                        },
                        permissions: [{ type: "root" }],
                    });
                    localStorage.setItem('sessionExpiryTime', sessionTime);
                    const sessionKeyData = {
                        privateKey,
                        permissions,
                    };
                    await saveIndexKey('sessionKeyData', sessionKeyData);
                    return { userPermissions: permissions, userSessionKey: sessionKey };
                }
                else {
                    const account = privateKeyToAccount(stored.privateKey);
                    const sessionKey = new LocalAccountSigner(account);
                    const grantedPermissions = stored.permissions;
                    const grantedSessionKey = sessionKey;
                    return { userPermissions: grantedPermissions, userSessionKey: grantedSessionKey };
                }
            } catch (error) {
                console.error('Error granting permissions:', error);
            }
        } else {
            console.log('smartAccountClient or smartAccount is not ready yet');
        }
    };
    return { grantPermissions }
}